import { type ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { FONT_WEIGHT } from '@/shared/styles/typography'

interface Props {
  // 右端の常時可視 action slot (任意). 現状 caller は渡さない.
  rightSlot?: ReactNode
}

// 録音 state は MeetingTabBar の録音中 indicator + Body の StatusLine /
// ProcessingChecklist で表現済のため、 Header label には冗長. 単に
// container 名「記録」 を default color で表示する.
export const Header = ({ rightSlot }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      px: 2,
      py: 1.25,
      borderBottom: `1px solid ${colorTokens.border.default}`,
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontWeight: FONT_WEIGHT.semibold,
        color: colorTokens.fg.default,
      }}
    >
      記録
    </Typography>
    {rightSlot && <Box sx={{ ml: 'auto' }}>{rightSlot}</Box>}
  </Box>
)
